// extracted by css-extract-rspack-plugin
export default {"spinner":"_9323a693"};